import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  const { endControlAvailable, endControlVisible, startControlAvailable, startControlVisible } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".scroll-control",
    style: this.helpers.getStyle()
  }, /* @__PURE__ */ jsx("div", {
    sel: ".scroll-back-container",
    class: { visible: startControlVisible }
  }, startControlAvailable ? /* @__PURE__ */ jsx("div", {
    sel: ".scroll-button",
    attrs: {
      role: `button`,
      tabindex: 0
    },
    on: {
      click: this.helpers.scrollBack
    }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `arrow-left` }
  })) : null), /* @__PURE__ */ jsx("div", {
    sel: ".scroll-forward-container",
    class: { visible: endControlVisible }
  }, endControlAvailable ? /* @__PURE__ */ jsx("div", {
    sel: ".scroll-button",
    attrs: {
      role: `button`,
      tabindex: 0
    },
    on: {
      click: this.helpers.scrollForward
    }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `arrow-right` }
  })) : null));
}
